import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Logo.module.css';

export default function Logo({ animate }) {
  return (
    <div className={`${styles.logo} ${animate ? styles.animateLogo : ''}`}>
      <Link to="/">
        <img src="/logo-small.png" alt="Castly Logo" className={styles.logoImg} />
      </Link>
    </div>
  );
}
